import pick from "lodash/pick";

import { Route } from "../../core/types";
import { getCount } from "./dimensions";
import { VenueDataBag } from "./types";

const getAttemptsCount = (route: Route, { routeStats }: VenueDataBag) =>
  pick(routeStats[route.uuid], ["attemptsCount", "successesCount", "flashesCount"]);

export const metrics = {
  count: {
    getter: getCount,
    label: "Routes",
  },
  attemptsCounts: {
    getter: getAttemptsCount,
    label: "Attempts",
    keyLabels: {
      attemptsCount: "Attempts",
      successesCount: "Ticks",
      flashesCount: "Flashes",
    },
    colorMap: {
      attemptsCount: "#F1F1F4",
      successesCount: "#00FF44",
      flashesCount: "#FFFF00",
    },
  },
};

export type MetricId = keyof typeof metrics;
export const metricGetters = {
  count: (_route: Route) => 1,
  attemptsCounts: getAttemptsCount,
} as const satisfies Record<
  string,
  (route: Route, bag: VenueDataBag) => number | Record<string, number>
>;
